// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
let nextInstanceId = 0;
const Comment = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
  const instanceId = React.useState(() => `Comment-${++nextInstanceId}`)[0];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 18}
      height={size ?? 18}
      fill="none"
      viewBox="0 0 18 18"
      ref={ref}
      {...props}
    >
      <mask id={`${instanceId}-Comment_a`} fill="#fff">
        <path
          fillRule="evenodd"
          d="M4 4a1 1 0 0 0-1 1v9.87a.5.5 0 0 0 .836.37L7.4 12H14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="currentColor"
        d="m3.836 15.24-.672-.74zM7.4 12v-1h-.387l-.286.26zM3 5h1V3a2 2 0 0 0-2 2zm0 4.398h1V5H2v4.398zM3 11h1V9.398H2V11zm0 3.87h1V11H2v3.87zm.836.37-.672-.74a.5.5 0 0 1 .836.37H2c0 1.302 1.545 1.986 2.509 1.11zM7.4 12l-.673-.74-3.563 3.24.672.74.673.74 3.564-3.24zm6.6 0v-1H7.4v2H14zm1-1h-1v2a2 2 0 0 0 2-2zm0-6h-1v6h2V5zm-1-1v1h2a2 2 0 0 0-2-2zM4 4v1h10V3H4z"
        mask={`url(#${instanceId}-Comment_a)`}
      />
    </svg>
  );
};
const ForwardRef = forwardRef(Comment);
export default ForwardRef;
